import React, { useState } from 'react'
import { Sidebar, Navbar, Projects, Contact, Footer } from '../components'
import styled from 'styled-components'
import HeroSection from '../components/HeroSection'
import About from '../components/About'


const Styles = styled.div`
    font-family: "Open Sans", sans-serif;
    padding-top: 80px;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
      -moz-font-smoothing: antialiased;
      -o-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    
`

const Home = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <Styles>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />
            <HeroSection />
            <About />
            <Projects />
            <Contact />
            <Footer />
        </Styles>

    )
}

export default Home